import Location from '../../../hooks/Location';
import { useEffect, useState, useContext } from 'react';
import { useFirestoreGeneral, useFirestoreID, useFirestoreOrderBy } from '../../../firebase/useFirestore';
import { db, timestamp } from '../../../firebase/config';
import ButtonClickedSimple from '../../../hooks/ButtonClickedSimple';
import { Auth } from '../../../StateManagment/Auth'
import { Responses } from "../../../StateManagment/Responses";
import { client } from "../../../hooks/Client";
import uuid from 'react-uuid';
import timestampToDateInput from '../../../utils/timestampToDateInput';
import firebase from '../../../firebase/compat';
import NotesAttachments from '../../personas/reports/NotesAttachments';
import ReadOnlyGuard from '../../common/ReadOnlyGuard';
import AutosaveStatus from '../../common/AutosaveStatus';
import useAutosaveField from '../../../hooks/useAutosaveField';

const NoteDetail = () => {
    // Context
      const [auth] = useContext(Auth)
      const [responses, setResponses] = useContext(Responses);
    
      // State
      const [body, setBody] = useState('');
      const [docid, setDocid] = useState('');
      const [date, setDate] = useState('');
    
      // Hooks
      const { save, status } = useAutosaveField('AdressNotes');
      const noteId = Location()[4];
      const personaId = Location()[3];
      const compagnyId = Location()[1];
      const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
    
      // Firestore
      const note = useFirestoreID('AdressNotes', noteId ? noteId : '');
    
      useEffect(() => {
        note && note.forEach(item => {
          setBody(item.Body);
          setDocid(item.docid);
          setDate(item.Timestamp.toDate().toLocaleDateString("nl-NL", options));
        });
      }, [note]);

      // Deze pagina heeft bewust geen opslaanknop: wijzigingen worden vanzelf
      // bewaard. `useAutosaveField` doet dat niet per toetsaanslag maar zodra de
      // gebruiker even stopt, en schrijft bij het verlaten van de pagina alsnog
      // weg wat er nog klaarstaat (inbox #155). Het meldt ook 'Opgeslagen'
      // zodra de schrijfactie geslaagd is (inbox #151).
      const titleHandler = (e) => {
        save(e.target.dataset.docid, { Title: e.target.value });
      };

      const bodyHandler = (e) => {
        save(e.target.dataset.docid, { Body: e.target.value });
      };

      const dateHandler = (e) => {
        const selectedDate = new Date(e.target.value);

        save(docid, { Timestamp: firebase.firestore.Timestamp.fromDate(selectedDate) });
      };
      
  return (
    <div className="main">
        <div className="main-container">
            <div className="page-header">
                <h1>Notitie instellingen</h1>
                <p>{date}</p>
            </div>
            <AutosaveStatus status={status} />
            {note && note.map(item => (
                <ReadOnlyGuard key={item.ID} edit="addresses.edit">
                    <div className="dashboard-container">
                        <h2>Titel</h2>
                        <input type="text" defaultValue={item.Title || ''} placeholder='Titel' data-docid={item.docid} onChange={titleHandler}/>
                        <h2>Datum</h2>
                        <input type="date" defaultValue={timestampToDateInput(item.Timestamp)} onChange={dateHandler}/>
                        <h2>Rapportage</h2>
                        <div>
                            <textarea defaultValue={item.Body} name="" id="" placeholder='Schrijf hier je rapportage' data-docid={item.docid} onChange={bodyHandler}></textarea>
                        </div>
                    </div>
                </ReadOnlyGuard>
            ))}
            <NotesAttachments
            parentId={noteId}
            parentType="adressNote"
            title="Documenten en foto's"
            />
        </div>
    </div>
  )
}

export default NoteDetail